import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";
import {PJJourneyNav} from "./pj-journey-nav";



function PJAccountHolderCheck(props) {
    const { state, dispatch, data } = useContext(PJContext);

    return  (
        <div className={"order-frame my-auto  journey-step " + props.current}>
            <div className="frame-content d-flex">
                <div className="my-auto mx-auto checkout">
                    <h4 className="center">CHECKOUT</h4>
                    <p className="center">Do you have a MyREV profile with us?</p>
                    <div className="row cta">
                        <div className="col-6 my-auto text-right">
                            <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color">
                                <button onClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_6_ACCOUNT_DETAILS} })} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">No</button>
                            </div>
                        </div>

                        <div className="col-6 my-auto text-left">
                            <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color">
                                <button onClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_5_ACCOUNT_CREDENTIALS} })} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <PJJourneyNav
                backClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_3_EXISTING_CUSTOMER} })}
            />
        </div>
    );
}

export { PJAccountHolderCheck };